export const SET_TEXT = 'SET_TEXT';
export const SET_DEFAULT_TEXT_ON = 'SET_DEFAULT_TEXT_ON';

export const SHOW_MODAL = 'SHOW_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';
export const SET_MODAL_IMG = 'set_modal_img';

export const QUIZ_PROTECTION_VALUE = 'QUIZ_PROTECTION_VALUE';
export const QUIZ_PROTECTION_FETCH_SUCCESS = 'QUIZ_PROTECTION_FETCH_SUCCESS';
export const QUIZ_PROTECTION_FETCH_FAIL = 'QUIZ_PROTECTION_FETCH_FAIL';
